export default __webpack_public_path__ + "static/media/Button - Icon.40aefe0f.svg";